import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Table,
  Row,
  Col,
  Tag,
  Button,
  Icon,
  Input,
  Modal
} from 'antd'
import API from '../../api/index'
import { getItem } from '../../api/utils'
import Action from './Action'
const Search = Input.Search

const ProfessionList = (props) => {
  const [professions, setProfessions] = React.useState([])
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = React.useState(undefined)
  const [is_search, setIs_search] = React.useState(false)
  const [Delete, setDelete] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(undefined)
  const [redirect, setRedirect] = React.useState(undefined)
  const type = getItem('type')
  const  columns = [
    {title: '#', dataIndex: 'key', key: 'key'},
    {title: 'Nombre', dataIndex: 'name', key: 'name'},
    {title: 'Activo', dataIndex: 'is_active', key: 'is_active',
      render: (text, record) => {
        return (
          <span>
            {record.is_active ? (
              <Icon type='check-circle' theme='twoTone' twoToneColor='#52c41a' />
            ) : (
              <Icon type='close-circle' theme='twoTone' twoToneColor='red' />
            )}
          </span>
        )
      }
    },
    {title: 'Acción', dataIndex: 'action', key: 'action',
      render: (text, record) => {
        return (
          <span>
            <Tag color='blue' onClick={() => handleViewProfession(record._id)}>Ver detalle</Tag>
            <Tag color='orange' onClick={() => handleUpdateProfession(record._id)}>Editar</Tag>
            <Action profession={record} />
            <Tag color='#26D543' onClick={() => handlePersons(record._id)}>Personas</Tag>
            {type === 'Administrador' && (
              <Tag color='#848C8B' onClick={() => handleDelete(record._id)}>Eliminar</Tag>
            )}
          </span>
        )
      }
    }
  ]

  const handleDownload = async () => {
    const users = 'profession'
    const result = await API.csv.download({
      model: users
    })
    if (result._id) {
      Modal.success({
        title: 'Descarga archivo csv',
        content: `El archivo csv fue enviado a su email exitosamente`
      })
    }
  }

  const handleDelete = async (id) => {
    setDelete(true)
    setDeleteId(id)
  }

  const handleProfessionDelete = async() => {
    const result = await API.profession.deletes(deleteId)
    if (result.nModified === 1) {
      setDelete(false)
      setDeleteId(undefined)
      Modal.success({
        title: 'La profesión ha sido eliminado exitosamente'
      })
    }
  }

  const handleAlertNot = () => {
    setDelete(false)
    setDeleteId(undefined)
  }

  const profession = async (page) => {
    const result = await API.profession.list(page)
    setProfessions(result)
  }

  const getProfessionByName = async (page) => {
    const result = await API.profession.search(page, search)
    setProfessions(result)
  }

  const handleCreateProfession = () => {
    setRedirect('/profession/create')
  }

  const handleViewProfession = (id) => {
    setRedirect(`/profession/detail/${id}`)
  }

  const handleUpdateProfession = (id) => {
    setRedirect(`/profession/update/${id}`)
  }

  const handlePersons = (id) => {
    setRedirect(`/persons/list/${id}`)
  }

   const handlePrev = () => {
    if (page > 1) {
      const pageTemp = page - 1
      setPage(pageTemp)
      profession(pageTemp)
    }
  }

  const handleNext = () => {
    if (professions.length >= 10) {
      const pageTemp = page + 1
      setPage(pageTemp)
      profession(pageTemp)
    }
  }

  const handleClearSearch = () => {
    setIs_search(false)
    setSearch(undefined)
    setPage(1)
    profession(1)
  }

  const onSearch = () => {
    setIs_search(true)
    setPage(1)
    getProfessionByName(1)
  }

  React.useEffect(() => {
    profession(page)

  }, [])

  if (redirect) {
    return (<Redirect to={redirect} />)
  }

  return (
    <div>
      <Row style={{ marginBottom: '20px' }}>
        <Col span={8}>
          <h3><strong>Listado de profesiones</strong></h3>
        </Col>
        <Col span={8}>
          <Search
            value={search}
            name='search'
            placeholder='Ingrese nombre de la profesión'
            onSearch={() => onSearch()}
            onChange={(event) => setSearch(event.target.value)}
            enterButton
          />
          {search && is_search && (
            <Tag
              color='red'
              style={{ marginTop: '5px' }}
              onClick={() =>handleClearSearch()}
            >
              Limpiar busqueda
            </Tag>
          )}
          {Delete && (
            <Modal
              title='Alerta'
              visible={Delete}
              onOk={() => handleProfessionDelete()}
              onCancel={() => handleAlertNot()}
              okText='Continuar'
              cancelText='Cancelar'
            >
              <p>¿Desea eliminar este profesión?</p>
            </Modal>
          )}
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <Button onClick={() => handleDownload()}>Descargar csv</Button>
          {' '}
          <Button onClick={() => handleCreateProfession()}>Crear profesión</Button>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={professions}
        size='small'
        pagination={{
          position: 'none'
        }}
      />
      <div style={{
        textAlign: 'right',
        marginTop: '10px'
      }}>
        <ul className='ant-pagination '>
          <li className={page === 1 ? ('ant-pagination-disabled ant-pagination-prev') : ('ant-pagination-prev')}>
            <a onClick={() => handlePrev()}>Anterior</a>
          </li>
          <li className='ant-pagination-item ant-pagination-item-1 ant-pagination-item-active'>{page}</li>
          <li className={professions.length >= 10 ? ('ant-pagination-next') : ('ant-pagination-disabled ant-pagination-next')}>
            <a onClick={() => handleNext()}>Siguiente</a>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default ProfessionList